import { EmptyIcon, HoldingErrorEnum, } from "../action-interfaces/Reports/HoldingReport";
import { ESortOrder } from "@domains/utils/sort";
import { HoldingUiState } from "@domains/aggregates/Reports/uiState";
import { ReportName, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import { ReportType, ReportName as DownloadReportName, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import { streamKeys } from "@adapters/repositories/stream/QuoteResponseMappper";
import { FilterData, Filters, SortData, } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
import * as URLConfig from "@frameworks/web/config/domain";
import UnderstandingReportName, { UnderstandingReportType, } from "@domains/entities/Reports/UnderstandingSection";
import { EmptyValidation, ReportsEnum } from "@domains/utils/commonText";
import { ReportGAEvents } from "@domains/trackers/gtmService";
import { ReportsGTMConstants } from "@domains/aggregates/Reports/ReportsGAConstants";
import { isLoginSourceEMT, triggerDownloadReportCallback, } from "@domains/utils/emtReportCallback";
import { ERports } from "../action-interfaces/Reports/DashboardSummary";
import abortControllerClass from "@domains/utils/abortControllerClass";
import { escapeRegexStr } from "@frameworks/web/utils/regex";
import { STREAMING_TYPE } from "@adapters/repositories/stream/IQuoteStreamRepo";
import throttle from "@domains/utils/throttle";
import { AssetCategory, } from "@domains/aggregates/interfaces/Reports/iPNLReport";
import { assetFilter, assetWiseProducts, simpleFilter, } from "@domains/mapper/Reports/AssetsAndProducts";
class HoldingReportPresenter {
    constructor(useCases, commonUsecase, understandUseCase, actions, downloadPDFReports, downloadExcelReports, sendEmailReports, dpTransactionUseCase, dpPullUseCase, dpTransactionSubmitUseCase, dpIds, useCasesStream, accountDetails, GTMService, dashBoardUsecase, dashboardActions, worker, abortController) {
        this.useCases = useCases;
        this.commonUsecase = commonUsecase;
        this.understandUseCase = understandUseCase;
        this.actions = actions;
        this.downloadPDFReports = downloadPDFReports;
        this.downloadExcelReports = downloadExcelReports;
        this.sendEmailReports = sendEmailReports;
        this.dpTransactionUseCase = dpTransactionUseCase;
        this.dpPullUseCase = dpPullUseCase;
        this.dpTransactionSubmitUseCase = dpTransactionSubmitUseCase;
        this.dpIds = dpIds;
        this.useCasesStream = useCasesStream;
        this.accountDetails = accountDetails;
        this.GTMService = GTMService;
        this.dashBoardUsecase = dashBoardUsecase;
        this.dashboardActions = dashboardActions;
        this.worker = worker;
        this.abortController = abortController;
        this.LThreeWindowbackClick = false;
        this.scrollState = 0;
        this.stopFamilyDetailsAPIcall = false;
        this.edisOrPledgeUrl = URLConfig.config.epledgeUrl;
        this.isNonPoaClient = false;
        this.emailAndDownload = false;
        this.initholdingReportData = {
            HoldingSummary: {
                date: "",
                message: "",
                totalInvestment: "",
                currentValue: "",
                totalPnL: "",
                daysPnL: "",
                totalPnLChange: "",
                daysPnLChange: "",
            },
            HoldingDetails: [],
            SearchData: "",
            FilterData: {
                simpleFilter: { name: "", filters: [] },
                assetFilter: { name: "", filters: [] },
                productAssetFilter: { name: "", filters: [] },
            },
            SortData: [],
            IsSummarize: false,
            HoldingDataFlags: {
                isOmneOnly: false,
                isBodEnabled: false,
                bodProcessInfoMessage: "",
            }
        };
        this.holdingReportData = this.initholdingReportData;
        this.sortState = new SortData("", "", ESortOrder.UNCHANGED);
        this.filterState = new FilterData(simpleFilter, assetFilter, {
            name: "",
            filters: [],
        });
        this.searchState = "";
        this.isSummarize = false;
        this.symbols = [];
        this.dashboardSymbols = [];
        this.filterApplied = false;
        this.initdashboardSummary = {
            holdingSummary: {
                date: undefined,
                message: undefined,
                totalInvestment: "",
                currentValue: "",
                totalPnL: "",
                daysPnL: "",
                totalPnLChange: "",
                daysPnLChange: "",
            },
            isOmneOnly: false,
            holdingDetail: [],
            holdingDashboardSummary: [],
        };
        this.dashboardSummary = this.initdashboardSummary;
        this.isHoldingStreamingOn = false;
        this.setSelectedRowIndex = (rowIndex) => {
            this.actions.setSelectedRowIndex(rowIndex);
        };
        this.onAssetChange = (selectedAsset, clearSimplefilter = false) => {
            let resetSimplefilter = this.filterState.simpleFilter;
            if ((selectedAsset.length === 1 &&
                selectedAsset[0] === AssetCategory.LifeInsurance) ||
                clearSimplefilter) {
                //  not applicable for life insurance tab ,
                resetSimplefilter = simpleFilter;
            }
            let newAssetFilter = assetFilter.filters.map((asset) => {
                return Object.assign(Object.assign({}, asset), { selected: selectedAsset.includes(asset.key) });
            });
            //when we select asset  , no need to select product
            let newAssetProductFilter = [];
            assetWiseProducts
                .get(AssetCategory.Total)
                .map((assetProduct) => {
                newAssetProductFilter.push({
                    title: assetProduct.display,
                    key: assetProduct.value,
                    selected: false,
                });
            });
            this.getFilteredHoldingReportData({
                simpleFilter: resetSimplefilter,
                assetFilter: {
                    name: assetFilter.name,
                    filters: newAssetFilter,
                },
                productAssetFilter: {
                    name: "Product Asset filter",
                    filters: newAssetProductFilter,
                },
            });
        };
        this.onProductChange = (product, filterName) => {
            const assetCodes = typeof product.value === "object" ? product.value : [product.value];
            let newAssetProductFilter = [];
            assetWiseProducts
                .get(AssetCategory.Total)
                .map((assetProduct) => {
                newAssetProductFilter.push({
                    title: assetProduct.display,
                    key: assetProduct.value,
                    selected: assetCodes.includes(assetProduct.value),
                });
            });
            this.getFilteredHoldingReportData({
                simpleFilter: this.filterState.simpleFilter,
                assetFilter: assetFilter,
                productAssetFilter: {
                    name: "Product Asset filter",
                    filters: newAssetProductFilter,
                },
            });
        };
        this.DashboardStreamingStart = false;
    }
    fetchEdisOrEpledgeUrl() {
        this.accountDetails.isNonPoaClient().then((result) => {
            this.isNonPoaClient = result;
            this.edisOrPledgeUrl = this.isNonPoaClient
                ? URLConfig.config.edisUrl
                : URLConfig.config.epledgeUrl;
        });
    }
    async getDefaultEmail() {
        const email = await this.accountDetails.getEmailId();
        this.userDefaultEmail = email;
    }
    async downloadAndSendReport(email, download) {
        if (email && download) {
            this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.Download} | ${email.reportType === ReportType.PDF
                ? ReportsGTMConstants.PDF
                : ReportsGTMConstants.EXCEL}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.Holding}`, `${ReportsGTMConstants.Download} / ${ReportsGTMConstants.Email}  | ${ReportsGTMConstants.Submit}`));
            this.emailAndDownload = true;
        }
        if (email) {
            this.actions.hideError(HoldingErrorEnum.EMAILSTATUS);
            const emailPayload = {
                toDate: email.toDate,
                reportType: email.reportType,
                emailIds: email.emailIds,
                reportName: ReportName.HOLDINGS,
                version: "/v1",
            };
            if (email === null || email === void 0 ? void 0 : email.accodes) {
                emailPayload.accodes = email === null || email === void 0 ? void 0 : email.accodes;
                emailPayload.isConsolidated = email === null || email === void 0 ? void 0 : email.isConsolidated;
                // emailPayload.reportName = "holdings" as DownloadReportName;
            }
            if (!this.emailAndDownload)
                this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.Download} | ${email.reportType === ReportType.PDF
                    ? ReportsGTMConstants.PDF
                    : ReportsGTMConstants.EXCEL}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.Holding}`, `${ReportsGTMConstants.Email} | ${ReportsGTMConstants.Submit}`));
            this.sendEmailReports.execute({
                onSuccess: (data) => {
                    this.actions.setError({
                        isOpen: data,
                        error: null,
                    }, HoldingErrorEnum.EMAILSTATUS);
                },
                onError: (error) => {
                    this.actions.setError({
                        isOpen: false,
                        error,
                    }, HoldingErrorEnum.EMAILSTATUS);
                },
            }, emailPayload);
        }
        if (download) {
            this.actions.hideError(HoldingErrorEnum.DOWNLOADSTATUS);
            const loginSource = await this.accountDetails.getLoginSrc();
            if (download.reportType === ReportType.PDF ||
                download.reportType === ReportType.PDF_DETAIL ||
                download.reportType === ReportType.PDF_SUMMARY) {
                const downloadPayload = {
                    date: download.date,
                    reportName: DownloadReportName.HOLDINGS,
                    subReportName: DownloadReportName.HOLDINGS,
                    reportType: download.reportType,
                    version: "/v1",
                };
                if (download === null || download === void 0 ? void 0 : download.accodes) {
                    downloadPayload.accodes = download === null || download === void 0 ? void 0 : download.accodes;
                    downloadPayload.isConsolidated = download === null || download === void 0 ? void 0 : download.isConsolidated;
                }
                if (download === null || download === void 0 ? void 0 : download.isPwdProtected)
                    downloadPayload.isPwdProtected = download === null || download === void 0 ? void 0 : download.isPwdProtected;
                if (!this.emailAndDownload)
                    this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.Download} | ${ReportsGTMConstants.PDF}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.Holding}`, `${ReportsGTMConstants.Download} | ${ReportsGTMConstants.Submit}`));
                if (isLoginSourceEMT(loginSource)) {
                    triggerDownloadReportCallback("GET", ReportType.PDF, DownloadReportName.HOLDINGS, { date: download.date }, loginSource);
                }
                else {
                    this.downloadPDFReports.execute({
                        onSuccess: (data) => {
                            this.actions.setError({
                                isOpen: data,
                                error: null,
                            }, HoldingErrorEnum.DOWNLOADSTATUS);
                        },
                        onError: (error) => {
                            this.actions.setError({
                                isOpen: false,
                                error: error,
                            }, HoldingErrorEnum.DOWNLOADSTATUS);
                        },
                    }, downloadPayload);
                }
            }
            else {
                const downloadPayload = {
                    date: download.date,
                    reportName: DownloadReportName.HOLDINGS,
                    subReportName: DownloadReportName.HOLDINGS,
                    version: "/v1",
                };
                if (download === null || download === void 0 ? void 0 : download.accodes) {
                    downloadPayload.accodes = download === null || download === void 0 ? void 0 : download.accodes;
                    downloadPayload.isConsolidated = download === null || download === void 0 ? void 0 : download.isConsolidated;
                    // downloadPayload.reportName = "holdings" as DownloadReportName;
                }
                if (download === null || download === void 0 ? void 0 : download.isPwdProtected)
                    downloadPayload.isPwdProtected = download === null || download === void 0 ? void 0 : download.isPwdProtected;
                this.emailAndDownload
                    ? null
                    : this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.Download} |  ${ReportsGTMConstants.EXCEL}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.Holding}`, `${ReportsGTMConstants.Download} | ${ReportsGTMConstants.Submit}`));
                if (isLoginSourceEMT(loginSource)) {
                    triggerDownloadReportCallback("GET", ReportType.EXCEL, DownloadReportName.HOLDINGS, { date: download.date }, loginSource);
                }
                else {
                    this.downloadExcelReports.execute({
                        onSuccess: (data) => {
                            this.actions.setError({
                                isOpen: data,
                                error: null,
                            }, HoldingErrorEnum.DOWNLOADSTATUS);
                        },
                        onError: (error) => {
                            console.log(error, "Email error");
                            this.actions.setError({
                                isOpen: false,
                                error: error,
                            }, HoldingErrorEnum.DOWNLOADSTATUS);
                        },
                    }, downloadPayload);
                }
            }
        }
        this.emailAndDownload = false;
    }
    downloadSmallCaseReport() {
        this.actions.hideError(HoldingErrorEnum.DOWNLOADSTATUS);
        const payload = {
            subReportName: DownloadReportName.HOLDINGS + "/" + DownloadReportName.SMALLCASE,
        };
        this.downloadExcelReports.execute({
            onSuccess: (data) => {
                this.actions.setError({
                    isOpen: data,
                    error: null,
                }, HoldingErrorEnum.DOWNLOADSTATUS);
            },
            onError: (error) => {
                this.actions.setError({
                    isOpen: false,
                    error: error,
                }, HoldingErrorEnum.DOWNLOADSTATUS);
            },
        }, payload);
    }
    async getHoldingStreamData(subscribe) {
        this.isHoldingStreamingOn = subscribe;
        try {
            const symb = subscribe ? this.symbols : [];
            const streamMapKey = [
                streamKeys[0],
                streamKeys[1],
                streamKeys[2],
                streamKeys[3],
            ];
            this.worker.onmessage = (event) => {
                const { reportData, type } = event.data;
                if (type === ReportName.HOLDINGS)
                    this.holdingReportData = reportData;
            };
            this.useCasesStream.streamQuote(STREAMING_TYPE.MINIQUOTE, subscribe, async (mappedData) => {
                try {
                    if (symb.includes(mappedData.symbol) && this.isHoldingStreamingOn) {
                        this.worker.postMessage({
                            type: ReportName.HOLDINGS,
                            streamData: mappedData,
                            reportData: this.holdingReportData,
                        });
                        let combinedState = new HoldingUiState(this.searchState, this.filterState, this.sortState, this.isSummarize);
                        const updateStreamData = await this.commonUsecase.getModifiedData(this.holdingReportData, combinedState);
                        throttle(() => this.actions.getHoldingReportData(Object.assign({}, updateStreamData)), 1000)();
                    }
                }
                catch (error) {
                    console.log(error);
                }
            }, symb, streamMapKey);
        }
        catch (error) {
            console.log(error);
        }
    }
    getDashboardData(req) {
        this.dashboardActions.hideError(ERports.HOLDINGS);
        this.dashboardActions.loader(ERports.HOLDINGS);
        this.dashboardSummary = this.initdashboardSummary;
        this.dashboardActions.getDashboardHoldingSummary({
            data: this.initdashboardSummary.holdingDashboardSummary,
            summary: this.initdashboardSummary.holdingSummary,
            isOmneOnly: false,
            isBodEnabled: false,
            bodProcessInfoMessage: "",
        }, ERports.HOLDINGS);
        this.dashBoardUsecase.execute({
            onSuccess: (data) => {
                this.dashboardSummary = data !== null && data !== void 0 ? data : this.initdashboardSummary;
                this.commonUsecase
                    .dashboardSummarize(this.dashboardSummary, this.isSummarize)
                    .then((x) => {
                    this.dashboardActions.getDashboardHoldingSummary({
                        data: x === null || x === void 0 ? void 0 : x.holdingDashboardSummary,
                        summary: x === null || x === void 0 ? void 0 : x.holdingSummary,
                        isOmneOnly: !!(data === null || data === void 0 ? void 0 : data.isOmneOnly),
                        isBodEnabled: x.isBodEnabled,
                        bodProcessInfoMessage: x.bodProcessInfoMessage,
                    }, ERports.HOLDINGS);
                    this.dashboardActions.stopLoader(ERports.HOLDINGS);
                });
                this.dashboardSymbols = this.dashboardSummary.holdingDetail
                    .map((x) => x.quote.symbol)
                    .filter((val) => val.length > 0);
                this.getDashboardStreamData(true);
            },
            onError: (error) => {
                this.dashboardActions.stopLoader(ERports.HOLDINGS);
                this.dashboardActions.setError({
                    error,
                    isOpen: true,
                }, ERports.HOLDINGS);
            },
        }, req);
    }
    getDPTransactionHistory(requestData) {
        this.actions.hideError(HoldingErrorEnum.DP_TRANSACTION_ERROR_DATA);
        this.actions.hideDPEmptyValidation();
        this.actions.toggleDpTransactionLoader(true);
        this.dpTransactionUseCase.execute({
            onSuccess: (data) => {
                if (data.dpTranactions.length > 0)
                    this.actions.setDpTransactionHistory(data);
                else {
                    const emptyDpTransaction = EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.DP];
                    this.actions.setEmptyDPValidation({ emptyDpTransaction });
                }
                this.actions.toggleDpTransactionLoader(false);
            },
            onError: (error) => {
                this.actions.toggleDpTransactionLoader(false);
                this.actions.setError({
                    isOpen: true,
                    error: error,
                }, HoldingErrorEnum.DP_TRANSACTION_ERROR_DATA);
            },
        }, requestData);
    }
    async sendEmailForDPTransaction(email, download) {
        if (email && download) {
            this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.Download} | ${ReportsGTMConstants.PDF}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.Holding}`, `${ReportsGTMConstants.Email} / ${ReportsGTMConstants.Download} | ${ReportsGTMConstants.Submit}`));
            this.emailAndDownload = true;
        }
        if (email) {
            this.actions.hideError(HoldingErrorEnum.EMAILSTATUS);
            const emailPayload = {
                emailID: email === null || email === void 0 ? void 0 : email.emailIds[0],
                filePath: email === null || email === void 0 ? void 0 : email.filePath,
                reportName: ReportName.DP,
            };
            this.emailAndDownload
                ? null
                : this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.Download} | ${ReportsGTMConstants.PDF}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.Holding}`, `${ReportsGTMConstants.Email} | ${ReportsGTMConstants.Submit}`));
            this.sendEmailReports.execute({
                onSuccess: (data) => {
                    this.actions.setError({
                        isOpen: data,
                        error: null,
                    }, HoldingErrorEnum.EMAILSTATUS);
                },
                onError: (error) => {
                    this.actions.setError({
                        isOpen: false,
                        error,
                    }, HoldingErrorEnum.EMAILSTATUS);
                },
            }, emailPayload);
        }
        if (download) {
            const loginSource = await this.accountDetails.getLoginSrc();
            this.actions.hideError(HoldingErrorEnum.DOWNLOADSTATUS);
            if (download.reportType === ReportType.PDF) {
                const downloadPayload = {
                    requestBody: {
                        path: download.path,
                    },
                    reportName: DownloadReportName.DP,
                    method: "POST",
                };
                this.emailAndDownload
                    ? null
                    : this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.Download} | ${ReportsGTMConstants.PDF}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.Holding}`, `${ReportsGTMConstants.Download} | ${ReportsGTMConstants.Submit}`));
                if (isLoginSourceEMT(loginSource)) {
                    triggerDownloadReportCallback("POST", ReportType.PDF, DownloadReportName.DP, { path: download.path }, loginSource);
                }
                else {
                    this.downloadPDFReports.execute({
                        onSuccess: (data) => {
                            this.actions.setError({
                                isOpen: data,
                                error: null,
                            }, HoldingErrorEnum.DOWNLOADSTATUS);
                        },
                        onError: (error) => {
                            this.actions.setError({
                                isOpen: false,
                                error: error,
                            }, HoldingErrorEnum.DOWNLOADSTATUS);
                        },
                    }, downloadPayload);
                }
            }
        }
        this.emailAndDownload = false;
    }
    getDPIdList(accCode) {
        this.actions.toggleDpTransactionMainLoader(true);
        this.dpIds.execute({
            onSuccess: (data) => {
                this.actions.getDpIds(data);
                this.actions.toggleDpTransactionMainLoader(false);
            },
            onError: (error) => {
                this.actions.toggleDpTransactionMainLoader(false);
            },
        }, accCode ? accCode : "");
    }
    async submitSpecificRequest(requestData) {
        this.actions.hideError(HoldingErrorEnum.DP_TRANSACTION_SUBMIT_ERROR_DATA);
        let resultMessage = "";
        //this.actions.toggleDpTransactionLoader(true);
        await this.dpTransactionSubmitUseCase.execute({
            onSuccess: (data) => {
                resultMessage = data;
            },
            onError: (error) => {
                // this.actions.toggleDpTransactionLoader(false);
                this.actions.setError({
                    isOpen: true,
                    error: error,
                }, HoldingErrorEnum.DP_TRANSACTION_SUBMIT_ERROR_DATA);
            },
        }, requestData);
        return resultMessage;
    }
    getHoldingReportData(req) {
        this.actions.hideError(HoldingErrorEnum.ERROR_DATA);
        this.actions.hideEmptyValidation();
        this.actions.setHoldingLoader(true);
        // this.actions.getHoldingReportData(this.initholdingReportData);
        if (this.abortController.abortController.signal)
            this.abortController.abortController.abort();
        if (this.abortController.abortController.signal.aborted)
            this.abortController = new abortControllerClass(new AbortController());
        this.useCases.execute({
            onSuccess: (HoldingReportData) => {
                let emptyValidation = {
                    icon: "",
                    message: "",
                };
                if (HoldingReportData) {
                    this.holdingReportData = HoldingReportData;
                    this.filterState = this.filterApplied
                        ? this.filterState
                        : HoldingReportData.FilterData;
                    if (this.filterApplied) {
                        this.getFilteredHoldingReportData(this.filterState);
                    }
                    else {
                        this.actions.getHoldingReportData(this.holdingReportData);
                    }
                    this.actions.setEmptyValidation({
                        emptyValidation,
                    });
                }
                else {
                    this.symbols = [];
                    this.holdingReportData = Object.assign(Object.assign({}, this.initholdingReportData), { SearchData: this.searchState, FilterData: this.filterState, IsSummarize: this.isSummarize });
                    this.actions.getHoldingReportData(Object.assign(Object.assign({}, this.initholdingReportData), { SearchData: this.searchState, FilterData: this.filterState, IsSummarize: this.isSummarize }));
                    emptyValidation =
                        EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.HOLDINGS];
                    this.actions.setEmptyValidation({ emptyValidation });
                }
                this.symbols = this.holdingReportData.HoldingDetails.map((holding) => holding.quote.symbol).filter((sym) => sym !== "");
                this.getHoldingStreamData(true);
                this.actions.setHoldingLoader(false);
            },
            onError: (error) => {
                let errorCode = error.getErrorCode();
                this.actions.setHoldingLoader(false);
                if (errorCode !== DOMException.ABORT_ERR.toString() &&
                    typeof error != "undefined")
                    this.actions.setError({
                        error,
                        isOpen: true,
                    }, HoldingErrorEnum.ERROR_DATA);
            },
        }, (req === null || req === void 0 ? void 0 : req.familyAccodes)
            ? {
                familyAccodes: req.familyAccodes,
                abortSignal: this.abortController.abortController.signal,
            }
            : {
                abortSignal: this.abortController.abortController.signal,
            });
    }
    setHoldingLoader() {
        this.actions.setHoldingLoader(true);
    }
    getUnderstandingSectionData() {
        const payload = {
            reportName: UnderstandingReportName.HOLDINGS,
            type: UnderstandingReportType.SUMMARY_FIELD,
        };
        this.understandUseCase.execute({
            onSuccess: (data) => {
                this.actions.getUnderstandingSectionData(data);
            },
            onError: (error) => {
                // error action
                this.actions.setErrorUnderStandings({
                    error,
                    isOpen: true,
                });
            },
        }, payload);
    }
    async getFilteredHoldingReportData(filterState) {
        this.actions.hideEmptyValidation();
        this.filterState = filterState;
        // this.searchState = this.holdingReportData.SearchData;
        this.filterApplied = true;
        let combinedState = new HoldingUiState(this.searchState, this.filterState, this.sortState, this.isSummarize);
        const filterededHoldingReportData = await this.commonUsecase.getModifiedData(Object.assign(Object.assign({}, this.holdingReportData), { SearchData: this.searchState, FilterData: this.filterState, IsSummarize: this.isSummarize }), combinedState);
        let emptyValidation = {
            icon: "",
            message: "",
        };
        if (filterededHoldingReportData &&
            filterededHoldingReportData.HoldingDetails.length > 0) {
            this.actions.getHoldingReportData(filterededHoldingReportData);
            this.actions.setEmptyValidation({ emptyValidation });
        }
        else {
            emptyValidation = EmptyValidation[EmptyIcon.FILTER];
            this.actions.getHoldingReportData(filterededHoldingReportData);
            this.actions.setEmptyValidation({ emptyValidation });
        }
        if (filterededHoldingReportData.FilterData.assetFilter.filters.find((x) => x.selected === true) ||
            filterededHoldingReportData.FilterData.simpleFilter.filters.find((x) => x.selected)) {
            this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.FilterIcon} ${ReportsGTMConstants.Apply}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.Holding}`, `${this.filterState.simpleFilter.filters
                .map((x) => (x.selected === true ? x.title.concat(" ") : null))
                .join("")} ${this.filterState.assetFilter.filters
                .map((x) => (x.selected === true ? x.title.concat(" ") : null))
                .join("")}`));
        }
    }
    getSortedHoldingReportData(newSortState, GATagCall) {
        // if clicked on the same key then change the order otherwise sort in assending (default)
        this.sortState = newSortState;
        GATagCall
            ? this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.OrderIcon} | ${ReportsGTMConstants.Apply}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.Holding}`, `${this.sortState.displayName}`))
            : null;
        let combinedState = new HoldingUiState(this.searchState, this.filterState, this.sortState, this.isSummarize);
        this.commonUsecase
            .getModifiedData(this.holdingReportData, combinedState)
            .then((sortedHoldingReportData) => this.actions.getHoldingReportData(sortedHoldingReportData));
    }
    getSummarizeHoldingReportData(isSummarize) {
        this.isSummarize = isSummarize;
        let combinedState = new HoldingUiState(this.searchState, this.filterState, this.sortState, this.isSummarize);
        this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.SummarizeValues}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.Holding}`, `${this.isSummarize
            ? ReportsGTMConstants.Enable
            : ReportsGTMConstants.Disable}`));
        this.commonUsecase
            .getModifiedData(this.holdingReportData, combinedState)
            .then((summarizedHoldingReportData) => this.actions.getHoldingReportData(summarizedHoldingReportData));
        this.commonUsecase
            .dashboardSummarize(this.dashboardSummary, this.isSummarize)
            .then((data) => {
            this.dashboardActions.getDashboardHoldingSummary({
                data: data.holdingDashboardSummary,
                summary: data.holdingSummary,
                isBodEnabled: data === null || data === void 0 ? void 0 : data.isBodEnabled,
                bodProcessInfoMessage: data === null || data === void 0 ? void 0 : data.bodProcessInfoMessage,
            }, ERports.HOLDINGS);
        });
    }
    async getSearchHoldingReportData(input) {
        if (input.includes("\\"))
            input = input.replace(/\\/g, "");
        input = escapeRegexStr(input);
        this.searchState = input;
        // this.filterState = this.holdingReportData.FilterData; // set it to initial state
        this.searchState.length > 0
            ? this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.Search}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.Holding}`, `${input}`))
            : null;
        let combinedState = new HoldingUiState(this.searchState, this.filterState, this.sortState, this.isSummarize);
        this.actions.hideEmptyValidation();
        const searchedHoldingReportData = await this.commonUsecase.getModifiedData(this.holdingReportData, combinedState);
        let emptyValidation = {
            icon: "",
            message: "",
        };
        if (searchedHoldingReportData &&
            searchedHoldingReportData.HoldingDetails.length > 0) {
            this.actions.getHoldingReportData(searchedHoldingReportData);
            this.actions.setEmptyValidation({ emptyValidation });
        }
        else {
            emptyValidation = EmptyValidation[EmptyIcon.SEARCH];
            this.actions.getHoldingReportData(searchedHoldingReportData);
            this.actions.setEmptyValidation({ emptyValidation });
        }
    }
    clearSingleFilter(title) {
        var _a;
        (_a = this.filterState[title]) === null || _a === void 0 ? void 0 : _a.filters.forEach((filter) => {
            if (filter.selected)
                filter.selected = false;
            return filter;
        });
        this.getFilteredHoldingReportData(this.filterState);
    }
    // For removing filters
    removeFilters(title) {
        var _a, _b, _c, _d, _e, _f;
        const defaultFilter = (_b = (_a = this.filterState) === null || _a === void 0 ? void 0 : _a.simpleFilter) === null || _b === void 0 ? void 0 : _b.filters.map((filter) => {
            if (filter.title === title) {
                filter.selected = false;
            }
            return filter;
        });
        const defaultAssetFilter = (_d = (_c = this.filterState) === null || _c === void 0 ? void 0 : _c.assetFilter) === null || _d === void 0 ? void 0 : _d.filters.map((filter) => {
            if (filter.title === title) {
                filter.selected = false;
            }
            return filter;
        });
        const defaultProductAssetFilter = (_f = (_e = this.filterState) === null || _e === void 0 ? void 0 : _e.productAssetFilter) === null || _f === void 0 ? void 0 : _f.filters.map((filter) => {
            if (filter.title === title) {
                filter.selected = false;
            }
            return filter;
        });
        this.getFilteredHoldingReportData({
            simpleFilter: { name: "Script Filter", filters: defaultFilter },
            assetFilter: { name: "Asset filter", filters: defaultAssetFilter },
            productAssetFilter: {
                name: "Product Asset Filter",
                filters: defaultProductAssetFilter,
            },
        });
    }
    // For clearing all filters
    clearAllFilters() {
        let defaultFilter = this.filterState.simpleFilter.filters.map((filter) => {
            if (filter.selected) {
                filter.selected = false;
            }
            return filter;
        });
        let defaultAssetFilter = this.filterState.assetFilter.filters.map((filter) => {
            if (filter.selected) {
                filter.selected = false;
            }
            return filter;
        });
        let defaultProductAssetFilter = this.filterState.productAssetFilter.filters.map((filter) => {
            if (filter.selected) {
                filter.selected = false;
            }
            return filter;
        });
        //the new instance created bcoz state is not getting updating
        this.getFilteredHoldingReportData(new FilterData(new Filters("Script Filter", defaultFilter), new Filters("Asset filter", defaultAssetFilter), new Filters("Product Asset Filter", defaultProductAssetFilter)));
    }
    getDashboardStreamData(subscribe) {
        this.DashboardStreamingStart = subscribe;
        try {
            const symb = subscribe ? this.dashboardSymbols : [];
            const streamMapKey = [
                streamKeys[0],
                streamKeys[1],
                streamKeys[2],
                streamKeys[3],
            ];
            this.worker.onmessage = (event) => {
                const { reportData, type } = event.data;
                if (type === ReportName.HDASHBOARD)
                    this.dashboardSummary = reportData;
            };
            this.useCasesStream.streamQuote(STREAMING_TYPE.MINIQUOTE, subscribe, async (mappedData) => {
                try {
                    if (symb.includes(mappedData.symbol) &&
                        this.DashboardStreamingStart) {
                        this.worker.postMessage({
                            type: ReportName.HDASHBOARD,
                            streamData: mappedData,
                            reportData: this.dashboardSummary,
                        });
                        const updateStreamData = await this.commonUsecase.dashboardSummarize(this.dashboardSummary, this.isSummarize);
                        throttle(() => this.dashboardActions.getDashboardHoldingSummary({
                            data: updateStreamData.holdingDashboardSummary,
                            summary: updateStreamData.holdingSummary,
                            isBodEnabled: updateStreamData === null || updateStreamData === void 0 ? void 0 : updateStreamData.isBodEnabled,
                            bodProcessInfoMessage: updateStreamData === null || updateStreamData === void 0 ? void 0 : updateStreamData.bodProcessInfoMessage,
                        }, ERports.HOLDINGS), 1000)();
                    }
                }
                catch (error) {
                    console.log(error);
                }
            }, symb, streamMapKey);
        }
        catch (error) {
            console.log(error);
        }
    }
    saveProdAssetDropDown(prodAssetFilter, activeAssetTab) {
        this.actions.saveProdAssetDropDown(prodAssetFilter, activeAssetTab);
    }
    toggleQtyBreakDown(checked) {
        //used to  save state of quantity breakdown of holding table
        this.actions.saveSMTF(checked);
    }
    getDpPullEmail(req) {
        return new Promise((resolve, reject) => {
            return this.dpPullUseCase.execute({
                onSuccess: (status) => {
                    resolve(status);
                },
                onError: (error) => {
                    reject(false);
                },
            }, req);
        });
    }
}
export default HoldingReportPresenter;
